import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { ContentContainer, AccordionHeader, AccordionTitle, AccordionCloseClickingArea, AccordionCloseIconContainer } from './style';
import { ReactComponent as CloseIcon } from "../../static/images/circledClose.svg";
import { AccordionChildFileDownload } from './AccordionChildFileDownload';

export const AccordionComponent = ({ links }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [maxHeight, setMaxHeight] = useState("70px");
    const contentRef = useRef(null);
    const triggerContent = () => {
        if (isOpen) {
            setMaxHeight("70px");
            setIsOpen(false);
        } else {
            setMaxHeight(contentRef.current.scrollHeight + 'px');
            setIsOpen(true);
        }
    }
    return (
        <ContentContainer style={{ maxHeight }} ref={contentRef}>
            <AccordionCloseClickingArea onClick={triggerContent} />
            <AccordionHeader>
                <AccordionTitle>Documentazione</AccordionTitle>
                <AccordionCloseIconContainer isOpened={isOpen}>
                    <CloseIcon style={{ display: 'block', cursor: 'pointer' }} onClick={triggerContent} />
                </AccordionCloseIconContainer>
            </AccordionHeader>
            {
                links.map(link => link.label && link.url ? 
                    <AccordionChildFileDownload
                        key={link.url}
                        text={link.label}
                        href={link.url}
                    /> : <React.Fragment></React.Fragment>)
            }
        </ContentContainer>
    );
}

const mapStateToProps = state => ({ links: state.offer.offerLinks });

export const Accordion = connect(mapStateToProps)(AccordionComponent);